var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-why-choose-us-inner-box mhbox"},[_c('div',{staticClass:"web-why-choose-inner-icon",domProps:{"innerHTML":_vm._s(_vm.obj.svg)}}),_c('h5',[_vm._v(_vm._s(_vm.obj.title))]),_c('p',[_vm._v(_vm._s(_vm.obj.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }